import * as yup from "yup";

import {
  onlyIfFieldIsVisible,
  onlyIfPeselFieldIsVisible,
} from "./onlyIfFieldIsVisible";
import { onlyIfFieldIsVisibleProvince } from "./onlyIfFieldIsVisibleProvince";

export default function init(): void {
  yup.addMethod(yup.string, "onlyIfFieldIsVisible", onlyIfFieldIsVisible);
  yup.addMethod(yup.object, "onlyIfFieldIsVisible", onlyIfFieldIsVisible);
  yup.addMethod(
    yup.string,
    "onlyIfFieldIsVisibleProvince",
    onlyIfFieldIsVisibleProvince
  );
  yup.addMethod(
    yup.string,
    "onlyIfPeselFieldIsVisible",
    onlyIfPeselFieldIsVisible
  );
}
